import React from "react";
import CoPoDashboard from "../../ui/CoPoDashboard";

/**
 * Admin CO-PO Dashboard
 * Uses the unified CoPoDashboard component with role="admin"
 * This enables the Instructor filter and shows all institute data
 */
const AdminCoPoDashboard = () => {
  return <CoPoDashboard role="admin" />;
};

export default AdminCoPoDashboard;
